import { State } from "../types/State";
import { getQueryFromState } from "./getQueryFromState";

export function setUrlFromState(state: State) {
  const url = new URL(window.location.href);

  url.search = getQueryFromState(state);

  window.history.pushState({}, "", url.toString());
}
